var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_674_5849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8637 18L11.9318 18.9318C11.0856 19.7644 9.94467 20.2288 8.75756 20.224C7.57044 20.2192 6.43332 19.7455 5.5939 18.906C4.75447 18.0666 4.28075 16.9295 4.27592 15.7424C4.27108 14.5553 4.73553 13.4143 5.56809 12.5681L7.8284 10.3125C8.63917 9.50005 9.72972 9.02814 10.877 8.99329C12.0242 8.95843 13.1414 9.36327 14 10.125",
    stroke: "#D46D22",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1363 5.99997L13.0681 5.06809C13.9144 4.23553 15.0553 3.77108 16.2424 3.77592C17.4295 3.78075 18.5666 4.25447 19.4061 5.0939C20.2455 5.93332 20.7192 7.07044 20.724 8.25756C20.7289 9.44467 20.2644 10.5856 19.4319 11.4318L17.1716 13.6922C16.3602 14.5039 15.2693 14.975 14.1221 15.0089C12.9749 15.0429 11.858 14.6373 11 13.875",
    stroke: "#D46D22",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_674_5849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default "https://static.im-cdn.com/mjc/storefront/Florencia/static/media/Link.c1519891.svg";
export { ForwardRef as ReactComponent };